import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import DeleteModal from "../../components/modals/DeleteModal";
import TableFiltersSkeleton from "../../components/skeletons/TableFiltersSkeleton";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import { PaginationInfo } from "../../models/security.model";
import ProductCategoryListFilters from "./components/ProductCategoryListFilters";
import ProductCategoryTable from "./components/ProductCategoryTable";
import ModalAddCategory from "../../components/modals/ModalAddCategory";
import {
  GetMainCategoriesResponse,
  GetMainCategoryByIdResponse,
} from "../../models/productCategory.model";
import {
  DeleteMainCategory,
  GetMainCategories,
  GetMainCategoryById,
} from "../../services/productCategory.service";
import { toast } from "react-toastify";

// all types must update (todo) search any
const ProductCategoryList = () => {
  const [showFilter, setShowFilter] = useState(true);
  const [filterObject, setFilterObject] = useState<any>();
  const [productCategoryList, setProductCategoryList] = useState<any[]>([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAddCategoryModal, setOpenAddCategoryModal] = useState(false);
  const [categoryById, setCategoryById] = useState<
    GetMainCategoryByIdResponse
  >();
  const [selectedRowId, setSelectedRowId] = useState<number>();
  const [serviceName, setServiceName] = useState<string>("");
  const queryClient = useQueryClient();
  const history = useHistory<{
    id: number;
  }>();

  const handleExportExcel = () => {
    // export to excel (todo)
    // GetIbanExcelMutate({
    //   ...filterObject,
    // });
  };
  const handleDelete = (id: number) => {
    setOpenDeleteModal(true);
    setSelectedRowId(id);
  };
  const handleDeleteRcord = () => {
    DeleteMainCategoryMutate({ id: selectedRowId! });
  };

  const handleAddRcord = (value: any) => {
    // add record (todo)
    // value.iban = "IR" + value.iban;
    // CreateIbanMutate(value);
  };
  const handleRouteToProductDetail = (rowId: number) => {
    GetMainCategoryByIdMutate({ id: rowId });
    setServiceName("UpdateMainCategory");
  };
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    }
  );
  const { mutate: GetMainCategoriesMutate } = useMutation(GetMainCategories, {
    onSuccess: (data: ApiResultModel<GetMainCategoriesResponse[]>) => {
      if (data) {
        setProductCategoryList(data.data);
        setPageInfo(data.pageInfo);
      }
    },
    onError: () => {},
  });
  const { mutate: GetMainCategoryByIdMutate } = useMutation(
    GetMainCategoryById,
    {
      onSuccess: (data: ApiResultModel<GetMainCategoryByIdResponse>) => {
        if (data) {
          setCategoryById(data.data);
          setOpenAddCategoryModal(true);
        }
      },
      onError: () => {},
    }
  );

  // const { mutate: GetIbanExcelMutate } = useMutation(GetIbanExcel, {
  //   onSuccess: (data: any) => {
  //     if (data) {
  //     }
  //   },
  //   onError: () => {},
  // });

  const { mutate: DeleteMainCategoryMutate } = useMutation(DeleteMainCategory, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data) {
        GetMainCategoriesMutate({
          filter: filterObject,
          paginationInfo: currentPaginationInfo,
        });
        setOpenDeleteModal(false);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    GetMainCategoriesMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
    if (openAddCategoryModal) {
      if (serviceName === "UpdateMainCategory") {
        GetMainCategoryByIdMutate({ id: categoryById?.id! });
      } else {
        setCategoryById(undefined);
      }
    }
  }, [filterObject, currentPaginationInfo, openAddCategoryModal]);
  return (
    <div>
      <Grid container>
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Typography
              color={"#1565C0"}
              fontWeight={"bold"}
              padding={"0.5rem"}
              borderRadius={"5px"}
              sx={{
                cursor: "pointer",
                width: "fit-content",
                "&: hover": { color: "#fff", background: "#1565C0" },
              }}
              onClick={() => {
                setOpenAddCategoryModal(true);
                setServiceName("AddMainCategory");
              }}
            >
              <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
              افزودن گروه کالا
            </Typography>
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="فیلتر" arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/filter.png"
                alt=""
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={handleExportExcel}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box> */}
        </Grid>
        {/* {showFilter &&
          // replace with your condition isLoading (todo)
          (true ? (
            <Grid item xs={12} sx={{ marginBottom: "20px" }}>
              <ProductCategoryListFilters
                filterObject={filterObject!}
                setFilterObject={setFilterObject}
                setCurrentPaginationInfo={setCurrentPaginationInfo}
              />
            </Grid>
          ) : (
            <span style={{ marginBottom: "10px", width: "100%" }}>
              <TableFiltersSkeleton />
            </span>
          ))} */}
        <Grid item xs={12}>
          <ProductCategoryTable
            productCategoryList={productCategoryList}
            pageInfo={pageInfo}
            currentPaginationInfo={currentPaginationInfo}
            setCurrentPaginationInfo={setCurrentPaginationInfo}
            handelDelete={handleDelete}
            handleRouteToProductDetail={handleRouteToProductDetail}
          />
        </Grid>
      </Grid>
      <DeleteModal
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        text={
          <>
            آیا از <span style={{ color: "#E6123D" }}>حذف این گروه کالا</span>{" "}
            اطمینان دارید؟
          </>
        }
        handleDel={handleDeleteRcord}
        onCloseModal={() => setOpenDeleteModal(false)}
      />
      <ModalAddCategory
        openCategoryModal={openAddCategoryModal}
        setOpenCategoryModal={setOpenAddCategoryModal}
        modalTitle="افزودن گروه کالا"
        textfieldTitle="نام گروه کالا"
        serviceName={serviceName}
        categoryById={categoryById}
      />
    </div>
  );
};

export default ProductCategoryList;
